<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>审核</BreadcrumbItem>
          <BreadcrumbItem>CMEF展讯通审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">CMEF展讯通审核</div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="开通审核" name="0"> </TabPane>
        <TabPane label="修改审核" name="1"> </TabPane>
      </Tabs>
      <div class="searchPro">
        <Input
          search
          placeholder="请输入公司名称或主开通人"
          v-model="search"
          @on-search="searchPro"
          style="width: 230px"
        />

        <Button type="error" style="margin-left: 20px" @click="setTimes"
          >展讯通提交时间设置</Button
        >
      </div>
    </div>

    <div class="layout-content" style="background: transparent">
      <!-- <div v-if="list.length"> -->
      <div v-if="list.length">
        <Table
          :columns="showTabs == '0' ? columns : columnsNoHandel"
          :loading="loading"
          :data="list"
          ref="selection"
          @on-selection-change="changeEvent"
        >
          <template slot-scope="{ row }" slot="companyName">{{
            row.companyName
          }}</template>
          <template slot-scope="{ row }" slot="name">{{ row.name }}</template>
          <template slot-scope="{ row }" slot="phoneNumber">{{
            row.phoneNumber
          }}</template>
          <template slot-scope="{ row }" slot="email">{{ row.email }}</template>
          <template slot-scope="{ row }" slot="idType">
            {{
              row.idType == "IDC01"
                ? "中国大陆居民身份证"
                : row.idType == "IDC02"
                ? "护照"
                : row.idType == "IDC03"
                ? "港澳台居民居住证"
                : row.idType == "IDC04"
                ? "台胞证"
                : row.idType
            }}
          </template>
          <template slot-scope="{ row }" slot="idNumber">{{
            row.idNumber
          }}</template>
          <template slot-scope="{ row }" slot="department">{{
            row.department
          }}</template>
          <template slot-scope="{ row }" slot="jobTitle">{{
            row.jobTitle
          }}</template>
          <template slot-scope="{ row }" slot="cPeople">
            <span
              class="lookClass"
              style="cursor: pointer"
              @click="detailInfo(row, '1')"
              >查看</span
            >
          </template>
          <template slot-scope="{ row }" slot="number">{{
            row.number
          }}</template>
          <template slot-scope="{ row }" slot="firstFileUrl">
            <span
              class="lookClass"
              style="cursor: pointer"
              @click="detailUrl(row, '2')"
              >查看</span
            >
          </template>
          <template slot-scope="{ row }" slot="fileUrl">
            <span
              class="lookClass"
              style="cursor: pointer"
              @click="detailUrl(row, '1')"
              >查看</span
            >
          </template>
          <template slot-scope="{ row }" slot="upTime">
            <span v-if="row.upTime">{{ row.upTime | dateFormat }}</span>
          </template>
          <template slot-scope="{ row }" slot="state">
            {{
              row.state == "Pass"
                ? "审核通过"
                : row.state == "ChangeAgain"
                ? "修改审核被驳回"
                : row.state == "Change"
                ? "修改审核中"
                : row.state == "Wait"
                ? "待审核"
                : row.state == "Fail"
                ? "审核驳回"
                : ""
            }}
          </template>
          <template slot-scope="{ row }" slot="isdeal">
            <span
              v-if="row.state == 'Pass' || row.state == 'ChangeAgain'"
              class="lookClass"
              style="cursor: pointer"
              @click="detailNumbers(row, '1')"
              >修改订单数</span
            >
            <!-- <span v-if="row.state == 'Pass' || row.state == 'Change'" class="spanClass">|</span> -->

            <span v-if="row.state == 'Wait' || row.state == 'Change'">
              <Poptip
                confirm
                :title="PoptipTitle"
                @on-ok="setAudit(row, 1)"
                placement="left"
              >
                <span class="lookClass" @click="handleP(row, '3')">通过</span>
              </Poptip>
            </span>
            <span
              class="spanClass"
              v-if="row.state == 'Wait' || row.state == 'Change'"
              >|</span
            >
            <!-- <span v-if="row.state == 'Wait' || row.state == 'Change'" class="deleteClass" style="cursor:pointer" @click="rejectP(row, '0')">驳回</span> -->
            <span v-if="row.state == 'Wait' || row.state == 'Change'">
              <Poptip
                confirm
                :title="PoptipTitle"
                @on-ok="setAudit(row, 2)"
                placement="left"
              >
                <span class="lookClass" @click="handleB(row, '3')">驳回</span>
              </Poptip>
            </span>
          </template>
        </Table>
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <iModal
      title="修改订单数"
      v-model="rejectModel"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
    >
      <Input
        v-model="rejectValue"
        type="number"
        placeholder="请输入..."
      ></Input>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject()">确定</Button>
        <Button @click="rejectModel = false">取消</Button>
      </div>
    </iModal>
    <!-- 批量驳回 -->
    <iModal
      title="驳回原因"
      v-model="dialogPl"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
    >
      <Input
        v-model="rejectValuePl"
        type="textarea"
        :rows="4"
        placeholder="请输入..."
      ></Input>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitRejectPl()">确定</Button>
        <Button @click="dialogPl = false">取消</Button>
      </div>
    </iModal>

    <iModal
      title="次联系人"
      v-model="dialogCl"
      class-name="vertical-center-modal"
      width="900px"
      :mask-closable="false"
    >
      <Table
        :columns="columnsp"
        :loading="loading"
        :data="list2"
        ref="selection"
        @on-selection-change="changeEvent"
      >
        <template slot-scope="{ row }" slot="name">{{ row.name }}</template>
        <template slot-scope="{ row }" slot="phoneNumber">{{
          row.phoneNumber
        }}</template>
        <template slot-scope="{ row }" slot="email">{{ row.email }}</template>
        <template slot-scope="{ row }" slot="department">{{
          row.department
        }}</template>
        <template slot-scope="{ row }" slot="jobTitle">{{
          row.jobTitle
        }}</template>
      </Table>
    </iModal>

    <iModal
      title="展讯通提交时间设置"
      v-model="timeShow"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
    >
      <div class="block">
        <span class="required">*</span>
        <span class="demonstration" style="margin-right: 20px"
          >允许提交时间</span
        >
        <DatePicker
          v-model="valueTime"
          type="datetimerange"
          :split-panels="true"
          format="yyyy-MM-dd HH:mm"
          placeholder="选择提交时间"
          style="width: 300px"
        ></DatePicker>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitTime()">确定</Button>
        <Button @click="timeShow = false">取消</Button>
      </div>
    </iModal>
    <div class="catalogue-content"></div>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: "exhibition-info-carApply",
  data() {
    return {
      newsAudit: "0",
      productTypeOptions: [
        {
          value: "选项1",
          label: "黄金糕",
        },
      ],
      productTypeValue: "",
      dialogCl: false,
      modalDetail: false,
      loading: false,
      dialogPl: false,
      rejectValuePl: "",

      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: "",
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      CompanyName: "",
      valueTime: "",
      columns: [
        {
          title: "公司",
          slot: "companyName",
          align: "center",
        },
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "证件类型",
          slot: "idType",
          align: "center",
        },
        {
          title: "证件号",
          slot: "idNumber",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
        {
          title: "次开通人",
          slot: "cPeople",
          align: "center",
        },
        {
          title: "订单数",
          slot: "number",
          align: "center",
        },
        {
          title: "开通说明",
          slot: "firstFileUrl",
          align: "center",
        },
        {
          title: "提交时间",
          slot: "upTime",
          align: "center",
        },
        {
          title: "状态",
          slot: "state",
          align: "center",
        },
        {
          title: "操作",
          slot: "isdeal",
          align: "center",
        },
      ],
      columnsNoHandel: [
        {
          title: "公司",
          slot: "companyName",
          align: "center",
        },
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "证件类型",
          slot: "idType",
          align: "center",
        },
        {
          title: "证件号",
          slot: "idNumber",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
        {
          title: "次开通人",
          slot: "cPeople",
          align: "center",
        },
        {
          title: "订单数",
          slot: "number",
          align: "center",
        },
        {
          title: "变更资料说明",
          slot: "fileUrl",
          align: "center",
        },
        {
          title: "提交时间",
          slot: "upTime",
          align: "center",
        },

        {
          title: "操作",
          slot: "isdeal",
          align: "center",
        },
      ],
      columnsp: [
        {
          title: "主开通人",
          slot: "name",
          align: "center",
        },
        {
          title: "手机",
          slot: "phoneNumber",
          align: "center",
        },
        {
          title: "邮箱",
          slot: "email",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          align: "center",
        },
        {
          title: "职务",
          slot: "jobTitle",
          align: "center",
        },
      ],
      oppTime: [],
      searchField: "",
      list: [],
      list2: [],
      selection: [], // 选中项目
      addShow: false,
      rejectModel: false,
      modelTitle: "",
      rowUser: {},
      optOld: {},
      showTabs: "0",
      PoptipTitle: "",
      option: {},
      stateInit: "",
      rejectValue: "",
      currentEmail: "",
      type: [],
      idCategory: "",
      proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
      statusProType: ["wait"],
      timeShow: false,
      setTime: {
        startTime: "",
        endTime: "",
        exhibitionId: "",
      },

      updateExDd:"",
    };
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionInfo: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
      exhibitionId: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 产品审核";
    // this.initProType()
    console.log(this.exhibitionId.id);
    // this.exhibitionId =  this.$store.state.hostSetModule.hostExhibition.id
    this.init();
    this.timeNow();
  },
  methods: {
    ...mapActions({
      GetWaitAuth: "hostScan/GetWaitAuth",
      GetChangeAuth: "hostScan/GetChangeAuth",
      AuthPass: "hostScan/AuthPass",
      AuthFail: "hostScan/AuthFail",
      GetAllContactPerson: "hostScan/GetAllContactPerson",
      ChangeNumber: "hostScan/ChangeNumber",
      AuthChange: "hostScan/AuthChange",
      setContactTime: "hostSetModule/setContactTime",
      getcontacttime: "hostSetModule/getcontacttime",
    }),
    setTimes() {
      this.timeShow = true;
    },
    switchBrand(name) {
      this.pageIndex = 1;

      this.init();
    },

    initStatus() {
      this.pageIndex = 1;
      if (this.newsAudit == 0) {
        this.statusProType = ["wait"];
      }
      if (this.newsAudit == 1) {
        this.statusProType = ["pass", "notpass"];
      }
      this.init();
    },
    searchChick() {
      this.init();
      //     this.startDateStr = this.formatDate(this.oppTime[0])
      //   this.endDateStr = this.formatDate(this.oppTime[1])
    },
    // 转换日期格式
    formatDate(dateTime) {
      let date = new Date(dateTime);
      let YY = date.getFullYear() + "-";
      let MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      //    return YY + MM + DD + " " + hh + mm + ss;
      return YY + MM + DD;
    },
    async timeNow() {
      let timer = await this.getcontacttime(this.exhibitionId.id);
      console.log(timer, 1111111111);
      let array = [];
      array[0] = timer.time.startTime;
      array[1] = timer.time.endTime;
      this.valueTime = array;
    },
    async init() {
      let opt = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        exhibitionId: this.exhibitionId.id,
        type: "",
        CompanyName: this.CompanyName,
        sorts: [
          {
            PropertyName: "UpTime",
            Ascending: false,
          },
        ],
      };
      console.log(this.showTabs);
      if (this.showTabs == 1) {
        let proData = await this.GetChangeAuth(opt);
        console.log(proData, "000");
        this.list = proData.items;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
        console.log(this.totalCount, 111);
      } else {
        let proData = await this.GetWaitAuth(opt);
        console.log(proData, 11);
        this.list = proData.items;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
      }
    },

    // 查询产品类别
    async initProType() {
      let categoryData = await this.getProductByGroupId({
        groupId: this.hostExhibition.groupId,
        level: 0,
        loadChild: true,
      }); // 暂时先写死了值
      if (categoryData && categoryData.length) {
        categoryData.map((c) => {
          c.value = c.name;
          c.label = c.name;
          c.children = JSON.parse(JSON.stringify(c.list));
          c.children.map((v) => {
            v.value = v.name;
            v.label = v.name;
            v.children = JSON.parse(JSON.stringify(v.list));
            v.children.map((z) => {
              z.value = z.name;
              z.label = z.name;
              z.children = JSON.parse(JSON.stringify(z.list));
            });
          });
        });
        this.type = categoryData;
        console.log(this.type, "888888888");
      } else {
        this.type = [];
      }
    },

    async setAllAudit() {
      const reqList = [];
      if (!this.selection.length) return;
      this.selection.forEach((c) => {
        reqList.push(c.joinId);
      });
      const bool = await this.setOneStepAudit({
        joinIds: reqList,
      });
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    edit(item) {
      this.editInfo = item;
    },
    searchPro() {
      this.CompanyName = this.search;
      this.pageIndex = 1;
      this.init();
    },
    changeEvent(selection) {
      this.selection = selection;
      console.log(this.selection);
    },

    handleP(row, index) {
      this.PoptipTitle = "您确定要通过吗？";
    },
    handleB(row, index) {
      this.PoptipTitle = "您确定要驳回吗？";
    },
    async setAudit(row, index) {
      let opt = {
        email: row.email,
        exhibitionId: row.exhibitionId,
      };
      if (index == 1) {
        const bool = await this.AuthPass(opt);
        if (bool && bool.successed) {
          this.$Message.success("操作成功");
          this.init();
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      } else {
        if (this.showTabs == 1) {
          const bool = await this.AuthChange(opt);
          if (bool && bool.successed) {
            this.$Message.success("操作成功");
            this.init();
          } else {
            this.$Message.error("操作失败，请重新尝试");
          }
        } else {
          const bool = await this.AuthFail(opt);
          if (bool && bool.successed) {
            this.$Message.success("操作成功");
            this.init();
          } else {
            this.$Message.error("操作失败，请重新尝试");
          }
        }
      }
    },
    rejectP(row, index) {
      this.rejectValue = "";
      this.rowUser = row;
      this.modelTitle = "请填写驳回原因：";
      this.dialogPl = true;
      //   }
    },

    // 修改订单数按钮
    async handleSubmitReject() {
      if (!this.rejectValue) {
        this.$Message.warning("修改订单数不能为空！");
        return;
      }
      const option = {
        // id: this.rowUser.id,
        Email: this.currentEmail,
        Number: Number(this.rejectValue),
        // exhibitionId: this.exhibitionId.id,
        exhibitionId: this.updateExDd ,
      };
      let bool = await this.ChangeNumber(option);
      if (bool && bool.successed) {
        this.rejectModel = false;
        this.updateExDd=""
        this.$Message.success("操作成功");
        this.init();
      } else {
        this.$Message.error("操作失败，请重新尝试");
      }
      //   }
    },
    async handleSubmitTime() {
      if (!this.valueTime) {
        this.$Message.warning("提交时间不能为空！");
        return;
      }
      let timer1 = moment(this.valueTime[0]).format("YYYY-MM-DD HH:mm");
      let timer2 = moment(this.valueTime[1]).format("YYYY-MM-DD HH:mm");
      console.log(timer1, timer2);
      this.setTime.startTime = timer1;
      this.setTime.endTime = timer2;
      this.setTime.exhibitionId = this.exhibitionId.id;
      let res = await this.setContactTime(this.setTime);
      console.log(res, 1111111);
      if (res.item1) {
        this.$Message.success("提交成功");
        this.timeNow();
      }

      this.timeShow = false;
    },
    // 查看详情   传id
    async detailInfo(item, index) {
      console.log(item);
      console.log(this.exhibitionId.id, 222);
      let req = {
        id: item.compId,
        email: item.email,
        exhibitionid: this.exhibitionId.id,
      };
      let info = await this.GetAllContactPerson(req);
      let array = [];
      if (info) {
        info.forEach((element) => {
          if (!element.isMain) {
            array.push(element);
          }
        });
        this.list2 = array;
        this.dialogCl = true;
        console.log(array);
        console.log(this.list2);
      }
    },
    // 资料
    detailUrl(item, index) {
      console.log(index, 333);
      if (index == 1 && !item.fileUrl) {
        if (!item.firstFileUrl) {
          this.$Message.warning("未上传资料!");
        } else {
          let url = item.firstFileUrl;
          window.open(url, "_blank");
        }
        return;
      } else if (index == 2 && !item.firstFileUrl) {
        this.$Message.warning("未上传资料!");
        return;
      }
      let url = index == 1 ? item.fileUrl : item.firstFileUrl;
      window.open(url, "_blank");
    },
    // 修改订单数
    detailNumbers(item) {
      this.rejectModel = true;
      this.currentEmail = item.email;
      this.updateExDd = item.exhibitionId;
    },
    // 修改展品显示、屏蔽
    async showToggle(item) {
      const bool = !!item.isShow;
      let result = await this.newRealeaseSetIsShow({
        id: item.id,
        setValues: {
          IsShow: bool,
        },
      });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    // 驳回确定按钮
    async handleSubmitRejectPl() {
      console.log(this.rowUser, 111);
      if (!this.rejectValuePl) {
        this.$Message.warning("驳回理由不能为空！");
        return;
      }
      let opt = {
        email: this.rowUser.email,
        exhibitionId: this.rowUser.id,
        // exhibitionId: this.exhibitionId.id,
      };
      if (this.showTabs == 1) {
        const bool = await this.AuthChange(opt);
        if (bool && bool.successed) {
          this.$Message.success("操作成功");
          this.init();
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      } else {
        const bool = await this.AuthFail(opt);
        if (bool && bool.successed) {
          this.$Message.success("操作成功");
          this.init();
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },

    hostExcelExportBackChange() {
      this.optOld = this.option;
      this.optOld.pageIndex = 1;
      this.optOld.pageSize = 999999;

      this.hostExcelExportBack();
    },

    // 展商导出
    async hostExcelExportBack() {
      let res = await this.postProductTagAuditLogExcelbyPage(this.optOld);
      let filename = "产品审核导出.xlsx";
      const blob = new Blob([res], { type: "application/vnd.ms-excel" }); // 构造一个blob对象来处理数据，并设置文件类型
      if (window.navigator.msSaveOrOpenBlob) {
        // 兼容IE10
        navigator.msSaveBlob(blob, filename);
      } else {
        const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href; // 指定下载链接
        a.download = filename; // 指定下载文件名
        a.click();
        URL.revokeObjectURL(a.href); // 释放URL对象
      }
      this.$Message.success("导出成功，耐心等待");
    },
  },
};
</script>
  
<style scoped lang="scss">
.required {
  color: red;
  margin-right: 4px;
}
.header-tabs {
  // display: flex;
  position: relative;
}
.searchPro {
  position: absolute;
  right: 24px;
  top: 0;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}
.ivu-table-wrapper {
  // padding-bottom: 20px!important;
  overflow: visible !important;
}
.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #1890ff;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
</style>
  